<template>
  <div class="imtextarea-wrap" @touchend="onCancelRecorder" @touchcancel="onCancelRecorder">
    <div v-if="showFuncBtns" class="func-btns-wrap">
      <div class="func-btns-box">
        <ChatFuncBtns :list="funcBtnList" @link="onAction" ref="chatFuncBtnsRef" />
      </div>
    </div>
    <div @click="closeFuncBtnAndDialog" class="input-row">
      <div @click.stop v-if="showQuickReply" class="quick-reply-wrap">
        <im-quick-reply @back="onHideQuickReply" @selected="onSelectedWord2" />
      </div>
      <div class="left-icon" @click.stop="onSwitchAudioText">
        <img
          v-if="!isAudioMessage"
          class="image"
          src="https://pharmacyimg.docbook.com.cn/mini_patient/pages/chat/voice.png"
        />
        <img
          v-else
          class="image"
          src="https://pharmacyimg.docbook.com.cn/mini_patient/pages/chat/keyboard.png"
        />
      </div>
      <form @submit.prevent class="input-content">
        <div v-if="isAudioMessage" class="input-text-inner" @touchstart.prevent="onStartRecorder">
          <span class="mic-btn">{{ voiceTitle }}</span>
        </div>
        <!-- <div
          v-if="showCustomInput || showCustomBtn"
          class="input-text-inner"
          @click.stop="onFocusInput"
        >
          {{ value }}
        </div> -->
        <input
          v-else
          id="inputContent"
          v-model="value"
          type="search"
          class="input-inner"
          enterkeyhint="send"
          autocomplete="off"
          @focus="isFocus"
          @blur="onBlur"
          @confirm="sendMsg(null)"
          @keyup.enter="sendMsg"
          @paste="onPaste"
        />
      </form>
      <!-- emo图标 -->
      <!-- <div @click.stop="onShowCustomBtn(0)" class="right-icon">
        <img
          class="image"
          src="https://pharmacyimg.docbook.com.cn/mini_patient/pages/chat/add.png"
        />
      </div> -->
      <div v-if="showBottomFuncBtn" class="right-icon" @click.stop="onShowCustomBtn(1)">
        <img
          class="image"
          src="https://pharmacyimg.docbook.com.cn/mini_patient/pages/chat/add.png"
        />
      </div>
    </div>
    <div v-if="showCustomBtn" class="custom-btn-list-wrap">
      <!-- 默认按钮 -->
      <div v-if="btnType === 1" class="custom-btns-list">
        <div
          v-for="(customBtn, index) in customBtnList"
          :key="index"
          class="custom-btn"
          @click="onSendFile(customBtn, $event)"
        >
          <div class="custom-btn-icon-wrap">
            <img v-if="customBtn.icon === 'quick-reply'" class="image" :src="quickReplyIcon" />
            <img v-if="customBtn.icon === 'image-filled'" class="image" :src="imageFilledIcon" />
            <img v-if="customBtn.icon === 'camera-filled'" class="image" :src="cameraFilledIcon" />
            <!-- <uni-icons
              v-else
              class="custom-btn-icon"
              :type="customBtn.icon"
              :size="26"
            ></uni-icons> -->
          </div>
          <div class="custom-btn-txt">
            <span class="text">{{ customBtn.title }}</span>
          </div>
        </div>
      </div>
      <!-- 表情 -->
      <div v-if="btnType === 0" class="scrollView" :scroll-y="true">
        <div class="custom-emoji-list">
          <div
            v-for="(item, index) in emojiName"
            :key="index"
            class="custom-emoji"
            @click.stop="onSelectEmoji(item)"
          >
            <img class="image" :src="emojiUrl + emojiMap[item]" />
          </div>
        </div>
      </div>
      <!-- 快捷回复 -->
      <div v-if="btnType === 3" class="im-quick-reply-wrap">
        <im-quick-reply @back="onShowCustomBtn(1)" @selected="onSelectedWord" />
      </div>
    </div>

    <!-- 录音动画 -->
    <div class="voice_an" v-if="recordering">
      <div class="voice_an_icon">
        <div class="wave one"></div>
        <div class="wave two"></div>
        <div class="wave three"></div>
        <div class="wave four"></div>
        <div class="wave five"></div>
        <div class="wave six"></div>
        <div class="wave seven"></div>
      </div>
      <div class="text">{{ voiceIconText }}</div>
    </div>
  </div>
</template>

<script>
import {
  sendTextMessage,
  sendImageMessage,
  sendVideoMessage,
  sendAudioMessage,
  sendCustomMessage,
  setInputStatus,
  TIM_TYPE,
  toVideoCall
} from '@/timpackage/utils/timInit'
import { pushAllMessages } from '@/views/funcPuzzle/utils/index.js'
import { emojiMap, emojiName, emojiUrl } from '@/timpackage/utils/emojiMap'
import { mapState, mapMutations } from 'vuex'
import ChatFuncBtns from './chatFuncBtns.vue'
import ImQuickReply from '../im-quick-reply/im-quick-reply.vue'
import quickReplyIcon from '@/static/quick-reply@2x.png'
import imageFilledIcon from '@/static/image@2x.png'
import cameraFilledIcon from '@/static/camera@2x.png'
import { recCreate, recDestroy, recOpen, recStop } from '../../utils/recorder'
import { Toast } from 'vant'
export default {
  components: {
    ImQuickReply,
    ChatFuncBtns
  },
  props: {
    // 功能菜单
    funcBtnList: {
      type: Array,
      default() {
        return []
      }
    },
    showFuncBtns: {
      // 是否展示功能按钮
      type: Boolean,
      default: true
    },
    bottomFuncBtnList: {
      // 自定义按钮
      type: Array,
      default() {
        return []
      }
    },
    showBottomFuncBtn: {
      // 是否展示底部功能按钮
      type: Boolean,
      default: true
    },
    content: {
      // 发消息必须数据
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      emojiMap,
      emojiName,
      emojiUrl,
      duration: 0,
      value: '',
      btnType: 1,
      showQuickReply: false, // 打开快捷回复
      showCustomInput: true,
      showCustomBtn: false,
      inputFocus: false,
      isAudioMessage: null,
      voiceIconText: '按住 说话',
      voiceTitle: '按住 说话',
      Recorder: null,
      PointY: null,
      recordering: false,
      recorderMove: false,
      quickReplyIcon,
      imageFilledIcon,
      cameraFilledIcon,
      customBtnList: [
        // { icon: 'image-filled', title: '照片', uploadType: ['album'] },
        // { icon: 'camera-filled', title: '拍摄', uploadType: ['camera'] }
        // { icon: 'quick-reply', title: '快捷回复', uploadType: ['quickReply'] }
        // { icon: 'videocam-filled', title: '视频', uploadType: ['phone'] }
      ],
      showEmoji: false,
      isShowModel: false
    }
  },
  computed: {
    ...mapState('IM', ['to', 'callStatus', 'reeditMessage'])
    // isFocus() {
    //   return this.isAudioMessage === false
    // }
  },
  watch: {
    bottomFuncBtnList(n) {
      // 更新底部功能按钮
      if (!n || !n.length) {
        this.customBtnList = [
          { icon: 'image-filled', title: '照片', uploadType: ['album'] },
          { icon: 'camera-filled', title: '拍摄', uploadType: ['camera'] }
        ]
      } else {
        this.customBtnList = n
      }
    },
    reeditMessage(n) {
      // 重新编辑
      if (n) {
        this.value += n
        this.SET_REEDIT('') // 重新编辑后清空vuex，避免只能赋值一次
      }
    }
  },
  mounted() {
    if (this.bottomFuncBtnList && this.bottomFuncBtnList.length) {
      this.customBtnList = this.bottomFuncBtnList
    }
    // 创建录音实例
    recCreate()
  },
  beforeUnmount() {
    // 销毁录音实例
    recDestroy()
  },
  methods: {
    ...mapMutations(['SET_UPDATE_IMLIST']),
    ...mapMutations('IM', [
      'SET_GROUP_VIDEO_LIVE',
      'SET_CALL_STATUS',
      'SET_REEDIT',
      'SET_IS_RECORDING'
    ]),
    // 开始录音
    onStartRecorder() {
      if (this.recordering) {
        return
      }
      this.duration = Date.now()
      this.voiceIconText = '按住 说话'
      this.recordering = true
      recOpen(() => {
        // 开发录音动画
        this.recordering = true
      })
    },

    // 停止录音
    onCancelRecorder() {
      if (this.recordering) {
        const dur = Date.now() - this.duration
        if (dur < 900) {
          this.voiceIconText = '时间太短'
          this.recordering = false
          // postMessage({
          //   action: 'recorderEnd' // 录音结束
          // })
          return
        }

        recStop(file => {
          // 录音结束后关闭录音动画
          this.recordering = false
          file &&
            sendAudioMessage({
              to: to.value,
              conversationType: TIM_TYPE.CONV_GROUP,
              payload: {
                file
              }
            })
        })
      }
    },
    closeFuncBtnAndDialog() {
      // 关闭所有弹框
      this.$refs.chatFuncBtnsRef &&
        this.$refs.chatFuncBtnsRef.closeFuncList &&
        this.$refs.chatFuncBtnsRef.closeFuncList()
      // 关闭会计回复弹框
      this.onHideQuickReply()
      this.showCustomInput = true
      this.showCustomBtn = false
      this.btnType = ''
      this.isAudioMessage = null
      // console.log('关闭所有弹框', this.showCustomInput)
    },
    onShowQuickReply() {
      this.showCustomInput = true
      this.$refs.quickReplyRef && this.$refs.quickReplyRef.showQuickReply()
    },
    onHideQuickReply() {
      this.$refs.quickReplyRef && this.$refs.quickReplyRef.hideQuickReply()
    },
    onShowEmoji() {
      this.showEmoji = true
    },
    onHideEmoji() {
      this.showEmoji = false
    },
    onShowFuncBtns() {
      this.showCustomInput = true
    },
    userGetAuth() {},
    isFocus() {
      this.isAudioMessage = false
      this.showCustomInput = false
      const params = {
        type: 1000,
        content: {
          status: true,
          title: this.content.doctorName
        }
      }
      setInputStatus({
        to: this.to,
        conversationType: TIM_TYPE.CONV_GROUP,
        payload: {
          data: JSON.stringify(params), //
          description: 'setStatus', // 用于标识该消息是设置状态
          extension: ''
        }
      })
    },
    onBlur() {
      const params = {
        type: 1000,
        content: {
          status: false,
          title: this.content.doctorName
        }
      }
      setInputStatus({
        to: this.to,
        conversationType: TIM_TYPE.CONV_GROUP,
        payload: {
          data: JSON.stringify(params), //
          description: 'setStatus', // 用于标识该消息是设置状态
          extension: ''
        }
      })
      this.showCustomInput = true
    },
    sendMsg() {
      if (!this.value || /^(\s|\n)+$/.test(this.value)) {
        // 不能发送空消息
        return
      }
      sendTextMessage({
        // 文本消息
        to: this.to,
        conversationType: TIM_TYPE.CONV_GROUP,
        payload: {
          text: this.value
        }
      })
      this.value = ''
    },
    onSendPic(files) {
      sendImageMessage({
        to: this.to,
        conversationType: TIM_TYPE.CONV_GROUP,
        payload: {
          file: files[0]
        }
      })
    },
    // 粘贴发送图片
    onPaste(e) {
      if (e.clipboardData.files[0]) {
        this.onSendPic(e.clipboardData.files)
      }
    },
    onSelectedWord2(data) {
      this.value += data || ''
      this.showQuickReply = false
      // this.$nextTick(() => {
      //   this.onFocusInput()
      // })
    },
    onSelectedWord(data) {
      this.value += data || ''
      this.btnType = 1
      this.$nextTick(() => {
        this.onFocusInput()
      })
    },
    onAction(item) {
      const { id } = item
      const hash = {
        capture: () => {
          this.chooseImage('camera')
        }, // 拍摄
        image: () => {
          this.chooseImage('album')
        }, // 照片
        quickReply: () => {
          this.showQuickReply = true
        } // 快捷回复
      }
      hash[id] && hash[id]()
      this.$emit('action', item)
    },
    onHideQuickReply() {
      // 关闭快捷回复
      this.showQuickReply = false
    },
    onShowCustomBtn(type) {
      this.btnType = type
      this.showCustomBtn = true
      this.isAudioMessage = null
    },
    hideCustomBtn() {
      this.showCustomBtn = false
    },
    onSwitchAudioText() {
      this.showCustomInput = true
      this.showCustomBtn = false
      this.isAudioMessage = !this.isAudioMessage
    },
    onFocusInput() {
      this.onFocus()
      this.showCustomInput = false
    },
    onFocus() {
      this.inputFocus = true
      this.showCustomBtn = false
      this.isAudioMessage = false
    },
    startVoiceTip() {
      Toast({
        title: '说话时间过短',
        icon: 'error',
        duration: 400
      })
    },
    startVoice(e) {
      console.log('recordering---', this.recordering)
      if (this.recordering) {
        return
      }
      // if (this.playing) {
      //   //如果音频正在播放 先暂停。
      //   this.stopAudio(this.AudioExam)
      // }
      this.recorderMove = true
      this.recordering = true
      this.SET_IS_RECORDING(true)
      this.voiceIconText = '正在录音...'
      this.voiceTitle = '松开 结束'
      this.PointY = e.touches[0].clientY

      recOpen(() => {
        // 开发录音动画
        this.recordering = true
      })
      // #endif
    },
    //move 正在录音中
    moveVoice(e) {
      if (!this.recordering) {
        return
      }
      const PointY = e.touches[0].clientY
      const slideY = this.PointY - PointY
      if (slideY > 2.56) {
        this.voiceIconText = '松开手指 取消发送 '
      } else if (slideY > 1.28) {
        this.voiceIconText = '手指上滑 取消发送 '
      } else {
        this.voiceIconText = '正在录音... '
      }
    },
    //结束录音
    endVoice() {
      this.recorderMove = false
      this.voiceTitle = '按住 说话'
      recStop(file => {
        console.log(file, 'recStop---------')
        if (!file) {
          this.voiceTitle = '按住 说话'
          this.recorderMove = false
          this.recordering = false
          return
        }
        const { duration } = file
        // 录音结束
        if (duration < 800) {
          this.recordering = false
          this.recorderMove = false
          Toast({
            message: '说话时间过短',
            icon: 'fail',
            duration: 400
          })
          return
        }
        // const contentDuration = Math.ceil(duration / 1000)
        sendAudioMessage({
          to: this.to,
          conversationType: TIM_TYPE.CONV_GROUP,
          payload: {
            file: file
          }
        })
        // 录音结束后关闭录音动画
        this.voiceTitle = '按住 说话'
        this.recorderMove = false
        this.recordering = false
      })
      this.SET_IS_RECORDING(false)
    },

    onSendFile({ icon, uploadType }) {
      const hash = {
        'image-filled': () => {
          this.chooseImage(uploadType)
          this.hideCustomBtn()
        }, // 图片
        'camera-filled': () => {
          this.chooseImage(uploadType)
          this.hideCustomBtn()
        }, // 拍照
        'videocam-filled': () => {
          this.customMessage()
          this.hideCustomBtn()
        }, // 添加视频
        'quick-reply': () => {
          this.quickReply()
        } // 快捷回复
      }
      hash[icon]()
    },
    chooseImage(sourceType) {
      this.SET_UPDATE_IMLIST(false) // 发生照片、拍照标记禁止更新聊天列表
      // 上传图片
      const uploadImage = () => {
        let input = document.getElementById('chooseImageIm')
        if (!input) {
          input = document.createElement('input')
          input.id = 'chooseImageIm'
          input.type = 'file'
          input.accept = 'image/*'
          input.style = 'position:fixed;left:-10000px;top:-10000px;opacity: 0;z-index:-1;'
          input.onchange = e => {
            const file = input.files[0]
            console.log(input.files)
            sendImageMessage({
              to: this.to,
              conversationType: TIM_TYPE.CONV_GROUP,
              payload: {
                file
              }
            })
          }
          document.body.appendChild(input)
        }
        input.click()
      }
      // 录视频
      const uploadVide = () => {
        let input = document.getElementById('chooseVideoIm')
        if (!input) {
          input = document.createElement('input')
          input.id = 'chooseVideoIm'
          input.type = 'file'
          input.accept = 'image/*'
          input.style = 'position:fixed;left:-10000px;top:-10000px;opacity: 0;z-index:-1;'
          input.capture = 'capture'
          input.onchange = e => {
            const file = input.files[0]
            console.log(input.files)
            sendImageMessage({
              to: this.to,
              conversationType: TIM_TYPE.CONV_GROUP,
              payload: {
                file
              }
            })
          }
          document.body.appendChild(input)
        }
        input.click()
      }
      if (sourceType === 'album') {
        uploadImage()
      }
      if (sourceType === 'camera') {
        uploadImage()
      }
    },
    customMessage(cb) {
      const {
        id,
        visitType, // visitType=5协同门诊，用群聊
        deptClassCode,
        deptClassName,
        deptID,
        deptName,
        doctorAdvice,
        doctorCardNo,
        doctorCardType,
        doctorID,
        doctorIDFromIM,
        doctorIcon,
        doctorName,
        doctorPhone,
        hospitalID,
        hospitalName,
        patientCardNo,
        patientCardType,
        patientID,
        patientIDFromIM,
        patientName,
        patientPhone,
        patientSex,
        payState,

        lowerDeptID,
        lowerDeptName,
        lowerDoctorID,
        lowerDoctorName = '',
        lowerDoctorPhone,
        lowerHospitalID,
        lowerHospitalName,
        lowerDoctorIDFromIM = ''
      } = this.content
      const dialogTitle = [patientName, lowerHospitalName, doctorName]
        .filter(item => item)
        .join('、')
      const userIDList = [patientIDFromIM, lowerDoctorIDFromIM, doctorIDFromIM]
      const videoMessagParams = {
        type: 50,
        content: {
          id,
          visitType,
          userIDList,
          lowerDoctorIDFromIM,
          lowerDoctorName,
          visitID: this.content.visitID,
          fromRole: 'Owner', // Owner 表示受者
          fromAccount: this.content.patientIDFromIM,
          fromName: this.content.patientName,
          toRole: 'Member', // Member 表示医生
          toAccount: this.content.doctorIDFromIM,
          toName: this.content.doctorName,
          groupId: '',
          roomID: `GROUP${this.content.visitID}`,
          userId: this.content.userID,
          userID: this.content.userID,
          // info: this.content,
          title: dialogTitle || this.content.patientName,
          deptClassCode,
          deptClassName,
          deptID,
          deptName,
          doctorAdvice,
          doctorCardNo,
          doctorCardType,
          doctorID,
          doctorIDFromIM,
          doctorIcon,
          doctorName,
          doctorPhone,
          hospitalID,
          hospitalName,
          patientCardNo,
          patientCardType,
          patientID,
          patientIDFromIM,
          patientName,
          patientPhone,
          patientSex,
          payState
        }
      }
      // 自定义消息
      // sendCustomMessage({
      //   to: this.to,
      //   conversationType: TIM_TYPE.CONV_GROUP,
      //   payload: {
      //     data: JSON.stringify(videoMessagParams), // 用于标识该消息是视频邀请
      //     description: '', // 视频邀请信息
      //     extension: ''
      //   }
      // })
      const param = Object.assign(videoMessagParams, {
        isMe: true
      })
      this.SET_GROUP_VIDEO_LIVE(true)
      toVideoCall(param, () => {
        typeof cb === 'function' && cb()
        pushAllMessages({
          hospitalID,
          visitID: this.content.visitID,
          messageName: 'contactPatient'
        })
        // 自定义视频消息, h5需要发送自定义消息
        sendCustomMessage({
          to: this.to,
          conversationType: TIM_TYPE.CONV_GROUP,
          payload: {
            data: JSON.stringify(videoMessagParams), // 用于标识该消息是视频邀请
            description: '', // 视频邀请信息
            extension: ''
          }
        })
      })
    },
    onSelectEmoji(data) {
      this.value += data
    },
    quickReply() {
      // 快捷接回复
      this.onShowCustomBtn(3)
    }
  }
}
</script>

<style lang="scss">
.imtextarea-wrap {
  position: relative;
  box-sizing: border-box;
  background: #f6f6f6;

  .image {
    display: block;
  }

  .func-btns-wrap {
    // 按钮展位
    position: relative;
    // height: 2.773333rem;
    border-top: 0.021333rem solid #dddddd;

    .func-btns-box {
      // position: absolute;
      // top: 0;
      // left: 0;
      // right: 0;
      // z-index: 2;
    }
  }

  .quick-reply-wrap {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 100%;
    z-index: 10;
    background: #fff;
    height: 8.533333rem;
  }

  .input-row {
    position: relative;
    display: flex;
    padding: 0.426667rem 0;
    align-items: center;
    border-top: 0.021333rem solid #dddddd;

    .right-icon,
    .left-icon {
      flex: 0 0 1.706667rem;

      .image {
        margin: auto;
        display: block;
        width: 1.28rem;
        height: 1.28rem;
      }
    }
    .input-content {
      margin-right: 0.64rem;
      flex: 1;
      background: #ffffff;
      border-radius: 0.170667rem;
      overflow: hidden;

      input {
        padding: 0 0.213333rem;
        border-radius: 0.170667rem;
        border: none;
      }

      .input-inner {
        box-sizing: border-box;
        display: block;
        width: 100%;
        height: 1.706667rem;
        font-family: PingFangSC-Regular, PingFang SC, Menksoft Budun;
      }
    }

    .input-text-inner {
      flex: 1;
      padding: 0 0.213333rem;
      min-height: 1.706667rem;
      line-height: 1.706667rem;
      white-space: nowrap;
      overflow: hidden;
      font-family: PingFangSC-Regular, PingFang SC, Menksoft Budun;

      .mic-btn {
        display: block;
        text-align: center;
        font-family: PingFangSC-Regular, PingFang SC, Menksoft Budun;
      }
    }
  }

  .custom-btns-list {
    border-top: 0.021333rem solid #dddddd;
    padding: 0.597333rem 0.981333rem 0.597333rem 0;
    display: flex;
    flex-wrap: wrap;

    .custom-btn {
      padding-left: 0.981333rem;
      flex: 0 0 2.773333rem;
      width: 2.773333rem;

      .custom-btn-icon-wrap {
        position: relative;
        display: flex;
        width: 2.773333rem;
        height: 2.773333rem;
        background: #ffffff;
        border-radius: 0.213333rem;
        overflow: hidden;

        .custom-btn-icon {
          margin: auto;
          display: block;
        }

        .image {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate3d(-50%, -50%, 0);
          display: block;
          width: 2.773333rem;
          height: 2.773333rem;
        }
      }

      .custom-btn-txt {
        display: block;
        padding-top: 0.341333rem;
        width: 100%;
        font-size: 0.426667rem;
        line-height: 0.853333rem;
        color: #222222;
        text-align: center;
      }
    }
  }

  .scrollView {
    height: 6.4rem;
  }

  .im-quick-reply-wrap {
    border-top: 0.021333rem solid #dddddd;
    height: 8.362667rem;
  }

  .custom-emoji-list {
    padding: 0.597333rem 0 0.597333rem 0.981333rem;
    display: flex;
    flex-wrap: wrap;

    .custom-emoji {
      padding: 0.213333rem;
      width: 1.706667rem;
      height: 1.706667rem;

      & > .image {
        display: block;
        width: 1.28rem;
        height: 1.28rem;
      }
    }
  }
}

.voice_an {
  width: 6.4rem;
  height: 6.4rem;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(41, 41, 41, 0.7);
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  z-index: 1000;
  border-radius: 0.213333rem;
  .text {
    padding-top: 0.64rem;
  }
  @keyframes runVoice {
    0% {
      height: 10%;
    }
    20% {
      height: 50%;
    }
    50% {
      height: 100%;
    }
    80% {
      height: 50%;
    }
    100% {
      height: 0%;
    }
  }
  .wave {
    width: 0.128rem;
    height: 100%;
    margin-left: 0.213333rem;
    border-radius: 1.066667rem;
    background-color: #999;
    vertical-align: middle;
    display: inline-block;
  }
  .voice_an_icon {
    width: 4.266667rem;
    height: 2.133333rem;
    line-height: 1.066667rem;
    margin: 1.066667rem 0;
  }
  .one {
    animation: runVoice 0.6s infinite 0.1s;
  }
  .two {
    animation: runVoice 0.6s infinite 0.3s;
  }
  .three {
    animation: runVoice 0.6s infinite 0.6s;
  }
  .four {
    animation: runVoice 0.6s infinite 0.1s;
  }
  .five {
    animation: runVoice 0.6s infinite 0.3s;
  }
  .six {
    animation: runVoice 0.6s infinite 0.6s;
  }
  .seven {
    animation: runVoice 0.6s infinite 0.1s;
  }
}
input {
  // border: none;
}
</style>
